import { useContext, useEffect, useState } from "react"
import PrimaryButton from "../../components/ui/PrimaryButton"
import DialogBox from "../../components/ui/DialogBox"
import { useNavigate } from "react-router-dom"
import AuthContext from "../../store/AuthContext"
import { createFlow, deleteFlowById, getAllFlows } from "../../services/flowService"

const FlowChartHome = () => {
    const navigate = useNavigate()

    const [showDialog, setShowDialog] = useState(false)
    const [flows, setFlows] = useState([])
    const [inputValue, setInputValue] = useState('')

    const getFlowsFromBackend = async () => {
        let flowsFromBackend = await getAllFlows()
        setFlows(flowsFromBackend)
    }

    const addFlow = async () => {
        await createFlow(inputValue, "93443da8-7703-11ee-b962-0242ac120016")
        setInputValue("")
        setShowDialog(false)
        getFlowsFromBackend()

    }


    useEffect(() => {
        getFlowsFromBackend()
    }, [])

    const deleteFlow = async (id) => {
        await deleteFlowById(id)
        getFlowsFromBackend()
    }

    return (
        <div>
            <div className="p-4 shadow-pink-100 shadow-2xl flex items-center text-lg text-slate-600 font-bold w-full">
                <div>Conversation Charts</div>
                <div className="ml-auto bg-red-200">
                    <PrimaryButton onClick={() => {
                        setShowDialog(prev => !prev)
                    }} text="+ Add Chart" />
                </div>
            </div>
            {
                showDialog && (
                    <DialogBox closeDialog={() => { setShowDialog(false) }} actionText="Add" action={addFlow}>
                        <div>Chart Name: </div>
                        <input className="border-[1px] border-black rounded" type="text" value={inputValue} onChange={(e) => { setInputValue(e.target.value) }} />
                    </DialogBox>
                )
            }
            <div className="p-8">
                <div className="relative rounded-xl overflow-auto">
                    <div className="shadow-sm overflow-hidden my-8">
                        <table className="border-collapse table-fixed w-full">
                            <thead>
                                <tr>
                                    <th className="border-b dark:border-slate-600 p-4 pl-8 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">Chart</th>
                                    <th className="border-b dark:border-slate-600 p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white dark:bg-slate-800">
                                {flows.map((flow, index) => <tr className="cursor-pointer  mt-2 " key={index} >

                                    <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-400 hover:text-blue-500" onClick={() => { navigate(`${flow.id}`) }}>
                                        {flow.name}
                                    </td>
                                    <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400 ml-4  pl-8" onClick={() => { navigate(`edit/${flow.id}`) }} >
                                        <button className="bg-gray-300 rounded px-2 py-[0.5px] border-2 border-transparent hover:bg-gray-400 focus:ring-2 focus:ring-blue-800">Add Languages</button>
                                    </td>
                                    <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400 ml-4  pl-8" onClick={() => { deleteFlow(flow.id) }} >
                                        <button className="bg-gray-300 rounded px-2 py-[0.5px] border-2 border-transparent hover:bg-gray-400 focus:ring-2 focus:ring-blue-800">Delete</button>
                                    </td>

                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                    <div className="absolute inset-0 pointer-events-none border border-black/5 rounded-xl dark:border-white/5"></div>
                </div>

            </div>

        </div >

    )
}

export default FlowChartHome